import "./App.css";
import ThemeProvider from "./theme";
import { AuthProvider } from "./context/auth-context";
import { RouterProvider } from "react-router-dom";
import router from "./routes";
import ThemeColorPresets from "./context/theme-color-presets";
import Cargando from "./components/CargandoGenerico";

function App() {
  return (
    <ThemeProvider>
      <ThemeColorPresets>
        <AuthProvider>
          <Cargando />
          <RouterProvider router={router} />
        </AuthProvider>
      </ThemeColorPresets>
    </ThemeProvider>
  );
}

export default App;
